import { render, staticRenderFns } from "./PageBlock.vue?vue&type=template&id=0277564f"
import script from "./PageBlock.vue?vue&type=script&lang=js"
export * from "./PageBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports